<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Acordo</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                </div>
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table v-if="ListSinistros!=''" :headers="headers" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    :search-value="searchValue">
                                    <template #item-snaDtInclusao="item">
                                        <span> {{ item.snaDtInclusao !== null ? formattedDate(item.snaDtInclusao) : null }}</span>
                                    </template>
                                      <template #item-snaDtPrimeiroVencimento="item">
                                        <span> {{ item.snaDtPrimeiroVencimento !== null ? formattedDate(item.snaDtPrimeiroVencimento) : null }}</span>
                                    </template>
                                    <template #item-snaDtCancelamento="item">
                                        <span> {{ item.snaDtCancelamento !== null ? formattedDate(item.snaDtCancelamento) : null }}</span>
                                    </template>
                                    <template #item-snaValorOriginal="item">
                                        <span> {{ item.snaValorOriginal !== null ? formatarValor(item.snaValorOriginal) : null }}</span>
                                    </template>
                                     <template #item-snaValorAcordo="item">
                                        <span> {{ item.snaValorAcordo !== null ? formatarValor(item.snaValorAcordo) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosAcordoView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
        itemsSelected:[],
    }),
    methods: {
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.sstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/sinistroacordodetalhe/' + item.snaIdCript);
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
            this.headers.push({ text: "Data Inicial", value: "snaDtInclusao", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }
            this.headers.push({ text: "Valor Original", value: "snaValorOriginal", sortable: true, });
            this.headers.push({ text: "Valor Acordo", value: "snaValorAcordo", sortable: true, });
            this.headers.push({ text: "Qtde Parcelas", value: "snaQtdeParcela", sortable: true, });
            this.headers.push({ text: "1º Vencimento", value: "snaDtPrimeiroVencimento", sortable: true, });
             this.headers.push({ text: "Status", value: "statusAcordo", sortable: true, });
            this.headers.push({ text: "Data Cancelamento", value: "snaDtCancelamento", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosAcordo/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistrosAcordo.sort(
                        (a, b) => (b.snaDtinclusao || '').localeCompare(a.snaDtinclusao || '')
                        );
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;
                
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
</style>
